// extracted by mini-css-extract-plugin
module.exports = {"bg":"GameAnimals_bg__3F51t","animal":"GameAnimals_animal__20Q2G","done":"GameAnimals_done__2OUxX","digAll":"GameAnimals_digAll__StJIo"};